// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".profile-image[data-v-379a6f60]{border-radius:50%}", "",{"version":3,"sources":["webpack://src/components/stanley/StanleyUserMessage.vue"],"names":[],"mappings":"AAAA,gCAAgC,iBAAiB","sourcesContent":[".profile-image[data-v-379a6f60]{border-radius:50%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
